import WithGASetup from '../../../components/WithGASetup';
import AuthContext from '../../../context/AuthContext.js';
import InviteParticipantsPage from './InviteParticipantsPage.js';

export default WithGASetup(InviteParticipantsPage, AuthContext);
